var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home_page",class:_vm.lang},[_c('nav-bar'),_c('download-panel'),_c('dict-header'),_c('users-info',{attrs:{"platform":"pc"}}),_c('feature-panel'),_c('show-panel'),_c('pop-up'),_c('dict-contact'),_c('dict-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }